// extracted by mini-css-extract-plugin
export default {"filters":"Products_filters__NN99q"};